import './auto-complete-text-field.scss'

import { defineComponent, PropType } from 'vue';

import { FIELD_VALUE_UPDATED } from "../../events";
import { reactiveVueMixin } from "@skinsoft/reactive-vue";
import _ from 'lodash';

export const AutoCompleteTextField = defineComponent({
    mixins: [reactiveVueMixin],
    props: {
        availableValues: {
            type: Array as PropType<String[]>,
            default: () => [],
        },
        value: {
            type: String,
        },
        placeholder: {
            type: String,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    template: require("./auto-complete-text-field.html"),
    data() {
        return {
            showSuggestions: false,
        }
    },
    computed: {
        valueCopy: {
            get(): String {
                return this.value ?? ""
            },
            set(newValue: String) {
                this.$emit(FIELD_VALUE_UPDATED, newValue)
            },
        },
        filteredSuggestions(): String[] {
            return this.availableValues.filter(value => {
                return value.includes(this.valueCopy as string) && value != this.valueCopy
            })
        },
    },
    methods: {
        onSuggestionClicked(value: string) {
            this.valueCopy = value
            this.showSuggestions = false
        },
        onFocus(event: FocusEvent) {
            this.showSuggestions = true
        },
        onBlur(event: FocusEvent) {
            setTimeout(
                () => {
                    this.showSuggestions = false
                },
                100
            )
        },
    },
})
